<template>
  <div v-loading="props.showLoading && loading" class="base-card-info account-applyed">
    <div class="info-card-title">
      资料审核
    </div>

    <div class="aa-content" :style="`visibility: ${loading? 'hidden' : 'unset'}`">
      <template v-if="underConfirm">
        <div class="pt-3 flex flex-col justify-center text-[#363636] w-[688px]">
          <div>
            尊敬的用户您好，你已经完成了连连注册，连连支付已经向您的手机号（{{ phoneLabels }}）发送了开户意愿通知短信，请注意查收，完成后可正常使用，如果没有收到短信也可以点击下方链接进行确认。
          </div>
          <div class="mt-3 text-center">
            <el-button @click="emit('go-back')">
              返回
            </el-button>
            <el-button type="primary" @click="openUrl">
              去确认
            </el-button>
          </div>
        </div>
      </template>
      <template v-else>
        <div style="padding-top: 36px;">
          <svg-icon v-if="underApplying" style="color: #E6A23C !important" icon="majesticons:clock-line" />
          <svg-icon v-if="normalStatus" icon="charm:circle-tick" />
          <svg-icon v-if="failedStatus" style="color: #F56C6C !important" icon="material-symbols:cancel-outline-rounded" />
        </div>

        <div class="aa-desc">
          <span v-if="underApplying">申请提交成功，请耐心等候</span>
          <span v-if="normalStatus">审核通过！</span>
          <span v-if="failedStatus">审核不通过</span>
          <div v-if="failedStatus" style="padding-top: 8px;">
            <label>{{ statusSubTitle }}</label>
          </div>
        </div>

        <div>
          <el-button @click="emit('go-back')">
            返回
          </el-button>
          <el-button v-if="normalStatus && showPrevStep" type="primary" @click="emit('to-next')">
            下一步
          </el-button>
          <el-button v-if="failedStatus" type="primary" @click="emit('re-apply')">
            重新申请
          </el-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useLianlianAccountStatus } from '../composables/useLianlianStatus';
import { fuzzyMobile, isNull } from '@core/tools';
import { onConfirm, SvgIcon } from '@vue3/components';
import { type ILianlianCard } from '../../types';
import { ELZTCardStatus } from '../../types/lianlian';
import { computed, PropType, ref, toRaw, watch } from 'vue';

const emit = defineEmits(['go-back', 'to-next', 're-apply']);

defineOptions({ naem: 'AccountApplySuccess' });

const props = defineProps({
  showPrevStep: {
    type: Boolean,
    default: false,
  },
  queryCardInfo: {
    type: Function as PropType<() => Promise<ILianlianCard>>,
    default() {
      return undefined;
    },
  },
  showLoading: {
    type: Boolean,
    default: true,
  },
  bankInfo: {
    type: Object as PropType<any>,
    default() {
      return {};
    },
  },
});

const loading = ref(props.showLoading);
const info = ref({} as ILianlianCard);

const {
  statusSubTitle,
  unapplyed,
  approvaling,
  approvalSuccess,
  approvalFailed,
  underConfirm,
} = useLianlianAccountStatus(info);

const lztStatus = computed(() => props.bankInfo?.lztStatus as ELZTCardStatus | undefined);
const lztNull = computed(() => isNull(lztStatus.value));

const underApplying = computed(() => lztNull.value ? approvaling.value || unapplyed.value : approvalFailed.value ? false : lztStatus.value === ELZTCardStatus.PENDING);
const normalStatus = computed(() => lztNull.value ? approvalSuccess.value : approvalFailed.value ? false : lztStatus.value === ELZTCardStatus.NORMAL);
const failedStatus = computed(() => lztNull.value ? approvalFailed.value : approvalFailed.value || lztStatus.value === ELZTCardStatus.FAIL);

const phoneLabels = computed(() => {
  const { regPhone, legalPhone } = props.bankInfo;

  if (!regPhone && !legalPhone) return '';

  if (regPhone === legalPhone) return fuzzyMobile(regPhone);

  return `${fuzzyMobile(regPhone)}；${fuzzyMobile(legalPhone)}`;
});

const openUrl = () => {
  window.open(info.value.openAccountWillUrl, '_blank');

  onConfirm({
    message: '是否已完成待意愿确认？',
    okText: '已完成',
    cancelText: '未完成',
    onOk: async () => {
      window.location.reload();
    },
  });
};

watch(
  () => props.bankInfo,
  (v) => {
    if (Object.keys(v).length > 0) {
      loading.value = false;
      info.value = toRaw(v);
    } else {
      loading.value = true;
    }
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped>
.account-applyed {
  height: 100%;
  overflow-y: auto;
}

.aa-content {
  height: calc(100% - 90px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .svg-icon {
    width: 68px !important;
    height: 68px !important;
    color: #67C23A !important;
  }

  .aa-desc {
    padding-top: 8px;
    padding-bottom: 22px;
    text-align: center;

    span {
      font-size: 16px;
      color: #344767;
      font-weight: 600;
    }

    label {
      font-size: 14px;
      color: #6B7891;
    }
  }
}
</style>
